import 'core-js/stable'
import { createApp, reactive } from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import settings from '../public/settings.json';
import store from './store'
import axios from 'axios'
import 'regenerator-runtime/runtime'
import './assets/css/kids-theme.css'

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// vue-select scss removed (not exported in vue-select v4)
// vue-tinymce-editor is Vue 2 only; use a stub or @tinymce/tinymce-vue for Vue 3
const tinymce = { template: '<div><textarea></textarea></div>' };

var moment = require("moment");

const baseAPI = axios.create({
  baseURL: settings.apiURL,
  withCredentials: true,  // Enable credentials (cookies) for all requests
});

const UNAUTHORIZED = 401;

baseAPI.interceptors.response.use(response => response, error => {
  const status = error.response ? error.response.status : null;
  if (status == UNAUTHORIZED) {
    // Quiz routes use their own kid-friendly auth page; the rest use the main site login.
    const currentPath = router.currentRoute.value.path;
    if (currentPath.startsWith('/quiz')) {
      router.push({ name: 'QuizAuth', query: { redirect: currentPath } });
    } else {
      router.push('/Login');
    }
  }
  return Promise.reject(error);
})

// === Language state ===
export const langState = reactive({
  currentLang: 'bm'
})

export function setLanguage(lang) {
  langState.currentLang = lang
  localStorage.setItem('preferredLang', lang)
}

const savedLang = localStorage.getItem('preferredLang')
if (savedLang) langState.currentLang = savedLang

const app = createApp(App)

app.use(router)
app.use(store)
app.use(CoreuiVue)

app.component("v-select", vSelect)
app.component("tinymce", tinymce)

app.mixin({
  methods: {
    GetBaseUrl() {
      return settings.apiURL;
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, { withCredentials: true })
        .then(response => {
          if (response.status == 202) return true;
          else return false;
        });
    },
    GetInfoUser() {
      this.$API
        .get(this.$LoginUserDetail, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.Name = this.info.name;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Error = true;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GoToSignUp() {
      let path = this.$router.currentRoute.value.path;
      if (path.toLowerCase() != "/index") {
        this.$router.push("/Index");
      }
    },
    GoToHome() {
      this.$router.push("/Index");
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/");
          }
        });
    },
    googleTranslateElementInit() {
      window.google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element"
      );
    },
  }
})

app.config.performance = true
app.config.globalProperties.$log = console.log.bind(console)
app.config.globalProperties.$API = baseAPI
app.config.globalProperties.$moment = moment

// aws
app.config.globalProperties.$uploadFile = 'aws/UploadVideoSessionIndex'
app.config.globalProperties.$uploadDocument = 'aws/UploadDocumentUser'
app.config.globalProperties.$UploadProfilePhoto = 'aws/UploadProfilePhoto'
app.config.globalProperties.$UploadBlog = 'aws/UploadBlog'
app.config.globalProperties.$UploadBlogFile = 'aws/UploadBlogFile'
app.config.globalProperties.$UploadBannerVoucher = 'aws/UploadBanner'
app.config.globalProperties.$UploadFlag = 'aws/UploadFlag'
app.config.globalProperties.$UploadVideoCreativeInsight = 'aws/UploadVideoCreativeInsight'

// update
app.config.globalProperties.$DeleteSession = 'update/DeleteSession'
app.config.globalProperties.$UpdatePaymentPackage = 'kiddo/update/UpdatePaymentPurchase'
app.config.globalProperties.$UpdateCompanyView = 'update/UpdateCompanyView'
app.config.globalProperties.$CompanyDetail = 'update/CompanyDetails'
app.config.globalProperties.$UserDetails = 'update/UserDetails'
app.config.globalProperties.$ValidateEmail = 'update/VerifyEmail'
app.config.globalProperties.$UpdateComUpdateQuestionDetailpanyView = 'update/UpdateQuestionDetailCompanyView'
app.config.globalProperties.$UpdateDetailQuestionCode = 'update/UpdateDetailQuestionCode'
app.config.globalProperties.$UpdateBlog = 'update/UpdateBlog'
app.config.globalProperties.$UpdateUserCountry = 'update/UpdateUserCountry'
app.config.globalProperties.$DeleteVideoCodeSession = 'update/DeleteSession'
app.config.globalProperties.$UpdateUserFeature = 'update/UpdateUserFeature'
app.config.globalProperties.$UpdateUserFeatureDirect = 'update/UpdateUserFeatureDirect'
app.config.globalProperties.$UpdateVoucherControlView = 'update/UpdateVoucherControlView'

// insert
app.config.globalProperties.$Register = 'kiddo/Insert/Register'
app.config.globalProperties.$LoginToken = 'kiddo/Insert/Login'
app.config.globalProperties.$UserAuth = 'kiddo/Insert/IsAuthenticated'
app.config.globalProperties.$ExtractAudioText = 'insert/ExtractAudioText'
app.config.globalProperties.$ForgotPassword = 'kiddo/insert/ForgotPassword'
app.config.globalProperties.$ValidateForgotPasswordCode = 'kiddo/insert/ValidateForgotPasswordCode'
app.config.globalProperties.$ChangePassword = 'kiddo/insert/ChangePassword'
app.config.globalProperties.$InsertSession = 'insert/SetSessionByToken'
app.config.globalProperties.$RegisterInterest = 'insert/RegisterInterest'
app.config.globalProperties.$RegisterSupport = 'insert/RegisterSupport'
app.config.globalProperties.$InsertQuestionGeneral = 'insert/InsertQuestionGeneral'
app.config.globalProperties.$InsertNextQuestion = 'insert/InsertNextQuestion'
app.config.globalProperties.$SubmitCompanyQuestion = 'insert/SubmitCompanyQuestion'
app.config.globalProperties.$InsertVoucher = 'insert/InsertVoucher'
app.config.globalProperties.$InsertShorlistedCandidate = 'insert/InsertShorlistedCandidate'
app.config.globalProperties.$ChangePasswordWoCode = 'insert/ChangePasswordWoCode'
app.config.globalProperties.$GenerateReport = 'insert/GenerateRank'
app.config.globalProperties.$SubmitFeedbacks = 'insert/AppFeedback'
app.config.globalProperties.$SubscribePackage = 'kiddo/insert/PurchaseProduct'
app.config.globalProperties.$SubscribePackage_AutoRegister = 'kiddo/insert/PurchaseProduct_AutoRegister'
app.config.globalProperties.$SubscribePackageFree = 'kiddo/insert/PurchaseProductFree'
app.config.globalProperties.$SubscribePackageVisa = 'kiddo/insert/SubscribePackageVisa'
app.config.globalProperties.$SignOut = 'Insert/SignOut'
app.config.globalProperties.$SetStatus = 'insert/SetStatus'
app.config.globalProperties.$EnterpriseContact = 'insert/EnterpriseContact'
app.config.globalProperties.$EvaluationCategory = 'insert/EvaluationCategory'
app.config.globalProperties.$SubmitVoucher = 'insert/InsertCustomVoucher'
app.config.globalProperties.$InsertCounterWebsite = 'insert/InsertCounterWebsite'
app.config.globalProperties.$InsertNewDataPosition = 'insert/InsertNewDataPosition'
app.config.globalProperties.$SendEmailAI = 'insert/SentEmailWaitingReport'
app.config.globalProperties.$RegisterNewStudent = 'kiddo/insert/RegisterNewStudent'
app.config.globalProperties.$InsertRegisterAffiliate = 'kiddo/insert/RegisterAffiliate'
app.config.globalProperties.$SetBankDetails = 'kiddo/insert/SetBankDetails'

// read
// NOTA: $API baseURL sudah '/flyhigh_be/api/kiddo/' — JANGAN tambah prefix 'kiddo/' lagi.
app.config.globalProperties.$LoginUserDetail = 'Read/LoginUserDetailWebs'
app.config.globalProperties.$LoginUserDetailWoLogin = 'Read/LoginUserDetail'
app.config.globalProperties.$GetFirstQuestion = 'read/GetFirstQuestion'
app.config.globalProperties.$GetNextQuestion = 'read/GetNextQuestion'
app.config.globalProperties.$GetUserHistory = 'read/GetUserHistory'
app.config.globalProperties.$GetListPosition = 'read/GetListPosition'
app.config.globalProperties.$GetListCountries = 'read/getlistcountries'
app.config.globalProperties.$GetNextQuestionVideo = 'read/GetVideoDetails'
app.config.globalProperties.$GetListUserHistory = 'read/GetListUserHistory'
app.config.globalProperties.$GetListPackageCandidate = 'read/GetListPackageCandidate'
app.config.globalProperties.$GetListPackageCompany = 'read/GetListPackageCompany'
app.config.globalProperties.$GetSuccessPaymentSubscription = 'read/GetSuccessPackageSubscriptionByUser'
app.config.globalProperties.$GetListSuccessPackageSubscription = 'read/GetListSuccessPackageSubscription'
app.config.globalProperties.$GetRank = 'read/GetRank'
app.config.globalProperties.$GetlistUser = 'read/GetListUsers'
app.config.globalProperties.$GetListReportNotGenerate = 'read/GetListReportNotGenerate'
app.config.globalProperties.$GetPackageCandidateById = 'read/GetPackageById'
app.config.globalProperties.$GetListVoucher = 'read/GetListVoucher'
app.config.globalProperties.$GetListContactUs = 'read/GetContactUs'
app.config.globalProperties.$SessionSummary = 'read/SessionSummary'
app.config.globalProperties.$GetVoucherAmount = 'read/GetVoucherAmount'
app.config.globalProperties.$GetListUserNotListedShortlisted = 'read/GetListUserNotListedShortlisted'
app.config.globalProperties.$GetListUserListedShortlisted = 'read/GetListUserListedShortlisted'
app.config.globalProperties.$SubscribePackageByUser = 'read/SubscribePackageByUser'
app.config.globalProperties.$GetDetailTotalCandidate = 'read/GetDetailTotalCandidate'
app.config.globalProperties.$GetTotalCandidate = 'read/GetTotalCandidate'
app.config.globalProperties.$GetSessionUrl = 'read/GetSessionUrl'
app.config.globalProperties.$GetSessionId = 'read/GetSessionId'
app.config.globalProperties.$GetListCategoryJob = 'read/GetListCategoryJob'
app.config.globalProperties.$GetListCategoryJobType = 'read/GetListCategoryJobType'
app.config.globalProperties.$GetListCategoryJobSeniority = 'read/GetListCategoryJobSeniority'
app.config.globalProperties.$GetQuestionAnswer = 'read/GetQuestionAnswer'
app.config.globalProperties.$GetFirstQuestionByCode = 'read/GetFirstQuestionByCode'
app.config.globalProperties.$GetFirstQuestionByQrCode = 'read/GetFirstQuestionByQrCode'
app.config.globalProperties.$GetNextQuestionByCode = 'read/GetNextQuestionByCode'
app.config.globalProperties.$GetTokenEmail = 'Read/GetTokenEmail'
app.config.globalProperties.$GetListField = 'read/GetListField'
app.config.globalProperties.$GetListExpertise = 'read/GetListExpertise'
app.config.globalProperties.$ListVideo = 'read/ListVideo'
app.config.globalProperties.$VerifyCode = 'read/VerifyCode'
app.config.globalProperties.$ListCreatedQuestion = 'read/ListCreatedQuestion'
app.config.globalProperties.$ListCreatedQuestionByid = 'read/ListCreatedQuestionByid'
app.config.globalProperties.$ListPackage = 'read/ListPackage'
app.config.globalProperties.$ListVoucher = 'read/ListVoucher'
app.config.globalProperties.$CheckQuestionCompanyCode = 'read/CheckQuestionCompanyCode'
app.config.globalProperties.$ListCodeInterviewr = 'read/ListCodeInterviewr'
app.config.globalProperties.$ListStatus = 'read/ListStatus'
app.config.globalProperties.$ListAllBlog = 'read/ListAllBlog'
app.config.globalProperties.$BlogPostById = 'read/BlogPostById'
app.config.globalProperties.$ListPublishBlog = 'read/ListPublishBlog'
app.config.globalProperties.$GetSubscription = 'read/GetSubscription'
app.config.globalProperties.$GetValueDashboard = 'read/GetValueDashboard'
app.config.globalProperties.$CheckVideoSessionIndex = 'read/CheckVideoSessionIndex'
app.config.globalProperties.$DataEvaluation = 'read/DataEvaluation'
app.config.globalProperties.$DataEvalutionCompany = 'read/DataEvalutionCompany'
app.config.globalProperties.$GetTotalUserHistory = 'read/GetTotalUserHistory'
app.config.globalProperties.$TotalNotListedShortlisted = 'read/TotalNotListedShortlisted'
app.config.globalProperties.$TotalNotListedShortlistedByUserId = 'read/TotalNotListedShortlistedByUserId'
app.config.globalProperties.$AskAI = 'read/AskAI'
app.config.globalProperties.$GetVoucherById = 'read/GetVoucherById'
app.config.globalProperties.$CheckExistingVoucherCode = 'read/CheckExistingVoucherCode'
app.config.globalProperties.$GetValueDashboardPositivenegative = 'read/GetValueDashboardPositiveNegative'
app.config.globalProperties.$GetListCountriesById = 'read/GetListCountriesById'
app.config.globalProperties.$GetTotalTodayVisitor = 'read/GetTotalTodayVisitor'
app.config.globalProperties.$GetLastWeekVisits = 'read/GetLastWeekVisits'
app.config.globalProperties.$GetLastMonthVisits = 'read/GetLastMonthVisits'
app.config.globalProperties.$GetMonthlyChartData = 'read/GetMonthlyChartData'
app.config.globalProperties.$GetListLanguages = 'read/GetListLanguages'
app.config.globalProperties.$GetFeatures = 'read/GetFeatures'
app.config.globalProperties.$GetListUserAccess = 'read/GetListUserAccess'
app.config.globalProperties.$GetThisWeekVisits = 'read/GetThisWeekVisits'
app.config.globalProperties.$GetListPositionCompany = 'read/GetListPositionCompany'
app.config.globalProperties.$GetDocDetails = 'read/GetDocDetails'
app.config.globalProperties.$GetListFeature = 'read/GetListFeatures'
app.config.globalProperties.$GetFeaturesByUserId = 'read/GetFeaturesByUserId'
app.config.globalProperties.$GetSessionUrlCandidate = 'read/GetSessionUrlCandidate'
app.config.globalProperties.$GetCheckSubscriptionValidDate = 'read/GetCheckSubscriptionValidDate'
app.config.globalProperties.$GetListTypeUserVoucher = 'read/GetListTypeUserVoucher'
app.config.globalProperties.$GetVoucherByVoucherId = 'read/GetVoucherByVoucherId'
app.config.globalProperties.$GetCheckCompanyView = 'read/GetCheckCompanyView'
app.config.globalProperties.$GetListControlVoucher = 'read/GetListControlVoucher'
app.config.globalProperties.$GetListIndustries = 'read/GetListIndustries'
app.config.globalProperties.$GetListProduct = 'kiddo/read/GetListProduct'
app.config.globalProperties.$GetListProductById = 'kiddo/read/GetListProductById'
app.config.globalProperties.$GetParentByUserId = 'kiddo/read/GetParentByUserId'
app.config.globalProperties.$GradeListAuthorize = 'kiddo/Read/GradeListAuthorize'
app.config.globalProperties.$GradeList = 'kiddo/Read/GradeList'
app.config.globalProperties.$ExamListAuthorize = 'kiddo/Read/ExamListAuthorize'
app.config.globalProperties.$SubjectListAuthorize = 'kiddo/Read/SubjectListAuthorize'
app.config.globalProperties.$GetExamCountry = 'kiddo/Read/GetExamCountry'
app.config.globalProperties.$ListSubjectByCountryId = 'kiddo/Read/SubjectListByCountryId'
app.config.globalProperties.$GetListGradePackage = 'kiddo/Read/GetListGradeProduct'
app.config.globalProperties.$GetListSubGradePackage = 'kiddo/Read/GetListSubGradeProduct'
app.config.globalProperties.$GetUserBankDetails = 'kiddo/Read/GetUserBankDetails'
app.config.globalProperties.$GetListTotalRegisterByUserId = 'kiddo/Read/GetListTotalRegisterByUserId'
app.config.globalProperties.$GetListTransactionUserId = 'kiddo/read/GetListTransactionUserId'
app.config.globalProperties.$GetTotalAmountUserId = 'kiddo/read/GetTotalAmountUserId'
app.config.globalProperties.$GetListArticle = 'kiddo/read/GetListArticle'
app.config.globalProperties.$GetBannerView = 'kiddo/read/GetBanner'
app.config.globalProperties.$GetListMemo = 'kiddo/read/GetListMemo'
app.config.globalProperties.$GetListYoutube = 'kiddo/read/GetListYoutube'
app.config.globalProperties.$GetListSlidePromotion = 'kiddo/read/GetListSlidePromotion'
app.config.globalProperties.$GetListPoster = 'kiddo/read/GetListPoster'
app.config.globalProperties.$GetListAktiviti = 'kiddo/read/GetListAktiviti'
app.config.globalProperties.$GetCheckingUserCoupon = 'kiddo/read/GetCheckingUserCoupon'
app.config.globalProperties.$GetCoupon = 'kiddo/read/GetCoupon'
app.config.globalProperties.$GetCouponByCode = 'kiddo/read/GetCouponByCode'
app.config.globalProperties.$GetCheckingEmailUserType = 'kiddo/read/GetCheckingUserType'
app.config.globalProperties.$GetParentDetailByEmail = 'kiddo/read/GetParentDetailByEmail'
app.config.globalProperties.$ValidateCart = 'kiddo/read/ValidateProduct'

// delete
app.config.globalProperties.$DeleteCompanyQuestionCodeById = 'delete/DeleteCompanyQuestionCodeById'
app.config.globalProperties.$DeleteCompanyQuestion = 'delete/DeleteCompanyQuestion'
app.config.globalProperties.$DeleteBlogPost = 'delete/DeleteBlogPost'
app.config.globalProperties.$DeleteDocument = 'delete/DeleteDocument'
app.config.globalProperties.$DeleteVoucher = 'delete/DeleteVoucher'
app.config.globalProperties.$DeleteBlogArticleFile = 'delete/DeleteBlogArticleFile'

// Blog Author Authentication
app.config.globalProperties.$LoginAdmin = 'adminauth/LoginAdmin'
app.config.globalProperties.$CheckAdminSession = 'adminauth/CheckAdminSession'
app.config.globalProperties.$LogoutAdmin = 'adminauth/LogoutAdmin'

// Blog Article Upload
app.config.globalProperties.$UploadBlogArticleHtml = 'insert/UploadBlogArticleHtml'
app.config.globalProperties.$ListBlogArticleFiles = 'read/ListBlogArticleFiles'
app.config.globalProperties.$GenerateBlogArticle = 'insert/GenerateBlogArticle'

// auth helpers
app.config.globalProperties.$SignUp = 'Insert/Register'
app.config.globalProperties.$LoginTokenWeb = 'Insert/LoginTokenWeb'
app.config.globalProperties.$RegisterManualStudentWithId = 'kiddo/Insert/RegisterNewManualStudent'
app.config.globalProperties.$RegisterParent = 'kiddo/Insert/Register'

// ── SEO: update head tags on every navigation ──────────────────────────────
const BASE_TITLE = 'FlyHigh Education Centre'
const BASE_DESC  = 'Platform tuisyen online terbaik Malaysia untuk pelajar SPM, UPKK, UASA dan PKSK. Guru berpengalaman, jadual fleksibel.'
const BASE_URL   = 'https://www.flyhigh.my'
const OG_IMAGE   = 'https://www.flyhigh.my/img/og-flyhigh.jpg'

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) { el = document.createElement('meta'); el.setAttribute('name', name); document.head.appendChild(el) }
  el.setAttribute('content', content)
}

function setOg(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`)
  if (!el) { el = document.createElement('meta'); el.setAttribute('property', property); document.head.appendChild(el) }
  el.setAttribute('content', content)
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', 'canonical'); document.head.appendChild(el) }
  el.setAttribute('href', href)
}

function trackPageView(path) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', { page_path: path })
  }
}

let fbqFirstNavHandled = false
function trackFbqPageView() {
  if (typeof window.fbq !== 'function') return
  // The base snippet already fires PageView on the initial full-page load,
  // so only fire on subsequent SPA route changes to avoid double counting.
  if (!fbqFirstNavHandled) {
    fbqFirstNavHandled = true
    return
  }
  window.fbq('track', 'PageView')
}

router.afterEach((to) => {
  let title = to.meta?.title || BASE_TITLE
  let desc  = to.meta?.description || BASE_DESC
  let canonical = to.meta?.canonical || (BASE_URL + to.fullPath)

// <title>
  document.title = title

  // <meta name>
  setMeta('description', desc)

  // Open Graph
  setOg('og:title',       title)
  setOg('og:description', desc)
  setOg('og:url',         canonical)
  setOg('og:image',       OG_IMAGE)

  // Twitter
  setMeta('twitter:title',       title)
  setMeta('twitter:description', desc)

  // Canonical
  setCanonical(canonical)

  // GA4 page_view (SPA)
  trackPageView(to.fullPath)

  // Meta Pixel PageView (SPA) — skips the initial load (base snippet handles it)
  trackFbqPageView()
})

app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', err, info)
  document.getElementById('app').innerHTML += '<pre style="color:red;background:#fff;padding:10px;position:fixed;top:0;left:0;z-index:9999;max-width:100%;overflow:auto">[Vue Error] ' + err.message + '\n' + (err.stack||'') + '\nInfo: ' + info + '</pre>'
}

try {
  app.mount('#app')
} catch(e) {
  console.error('[Mount Error]', e)
  document.getElementById('app').innerHTML = '<pre style="color:red;padding:20px">' + e.message + '\n' + e.stack + '</pre>'
}
